<template lang="pug">
  #right-click-menu(
    ref='rightMenu', v-if='rightMenuVisible',
    @blur='closeRightClickMenu',
    :style='{ top:top, left:left }'
  )
    p.section-title
      span {{ $t('Group -')}}&nbsp;{{ rightClickedItem.name }}
    p.right-click-menu-item(id="RightClickDesktopGroupsMenu-editLocation", @click.stop="rightClickGroupAction('editGroup', rightClickedItem )")
      font-awesome-icon.icon(icon="edit")
      span &nbsp; {{ $t('Edit location') }}
    .separator-line
    p.section-title(v-if='this.$store.state.Device.desktop_groups_selected_right.length > 1')
      span {{ $t(`${this.$store.state.Device.desktop_groups_selected_right.length} selected groups`) }}
    p.right-click-menu-parent(
      id="RightClickDesktopGroupMenu-update",
      @mouseover="displaySection = 'update'",
      @mouseleave="displaySection = undefined",
      @click.stop=""
    )
      font-awesome-icon.icon(icon="share")
      span &nbsp; {{ $t('Update') }}
      font-awesome-icon.icon.float-right(icon="chevron-right")
      section.sub-menu.sub-menu-left(v-if="displaySection === 'update'"
          :class="{'sub-menu-right': rightFreeSpace > 500 }"
        )
        p.right-click-menu-item(
          id="RightClickDesktopGroupsMenu-updateContents",
          @click.stop="rightClickGroupAction('updateContents')",
          :class="{ disabled: !(modificationsInSelected > 0) }"
        )
          font-awesome-icon.icon(icon="upload")
          span &nbsp; {{ $t(`Content`) }} &nbsp;
        p.right-click-menu-item(id="RightClickDesktopGroupsMenu-updateSchedule", @click.stop="rightClickGroupAction('updateSchedules')")
          font-awesome-icon.icon(icon="calendar-alt")
          span &nbsp; {{ $t('Schedule') }} &nbsp;
        p.right-click-menu-item(id="RightClickDesktopGroupsMenu-requestScreenshot", @click.stop="rightClickGroupAction('requestScreenshots')")
          font-awesome-icon.icon(icon="image")
          span &nbsp; {{ $t('Screenshot') }} &nbsp;
    p.right-click-menu-parent(
      id="RightClickDesktopMenu-restart",
      @mouseover="displaySection = 'restart'",
      @mouseleave="displaySection = undefined",
      @click.stop=""
    )
      font-awesome-icon.icon(icon="sync")
      span &nbsp; {{ $t('Restart') }}
      font-awesome-icon.icon.float-right(icon="chevron-right")
      section.sub-menu.sub-menu-left(v-if="displaySection === 'restart'",
          :class="{'sub-menu-right': rightFreeSpace > 500 }"
        )
        p.right-click-menu-item(id="RightClickDesktopGroupsMenu-restartRenderer", @click.stop="rightClickGroupAction('restartRenderers')")
          font-awesome-icon.icon(icon="sync")
          span &nbsp; {{ $t('Restart renderer') }}
        p.right-click-menu-item(id="RightClickDesktopGroupsMenu-restartCore", @click.stop="rightClickGroupAction('restartDevicesCore')")
          font-awesome-icon.icon(icon="sync")
          span &nbsp; {{ $t('Restart core') }}
        p.right-click-menu-item(id="RightClickDesktopGroupsMenu-restartOS", @click.stop="rightClickGroupAction('restartDevicesOS')")
          font-awesome-icon.icon(icon="sync")
          span &nbsp; {{ $t('Restart OS') }}
    .separator-line.light
    p.right-click-menu-item(id="RightClickDesktopGroupsMenu-clearContent", @click.stop="rightClickGroupAction('purgeContents')")
      font-awesome-icon.icon(icon="trash")
      span &nbsp; {{ $t('Clear content') }}
    .separator-line.light
    p.right-click-menu-item(id="RightClickDesktopGroupsMenu-deleteLocation", @click.stop="rightClickGroupAction('deleteGroup', rightClickedItem)")
      font-awesome-icon.icon(icon="ban")
      span &nbsp; {{ $t('Delete location') }}
    p.right-click-menu-item(id="RightClickDesktopMenu-identifyDevice", @click.stop="rightClickDesktopAction('identifyDevices')")
      font-awesome-icon.icon(icon="barcode")
      span &nbsp; {{ $t('Display onscreen info') }} &nbsp;
</template>

<script>
import Vue from 'vue'
import MediumIcon from '../Common/MediumIcon'
import mediaUtilsMixin from '../Common/mediaUtils.mixin'
import textUtilsMixin from '../Common/textUtils.mixin'

export default {
  props: [],
  mixins: [mediaUtilsMixin, textUtilsMixin],
  components: {
    MediumIcon
  },
  created () {
  },
  watch: {
    variableName: async (newVal, oldVal) => {
    }
  },
  data () {
    return {
      errors: {
      },
      rightMenuVisible: false,
      top: '0px',
      left: '0px',
      rightClickedItem: undefined,
      displaySection: undefined
    }
  },
  methods: {
    rightClickGroupAction (action, desktopgroup) {
      if (action === 'updateContents' && !(this.modificationsInSelected > 0)) return
      this.$emit('rightClickGroupAction', { action, desktopgroup })
      this.closeRightClickMenu()
    },
    // RIGHT-CLICK
    setRightClickMenuPosition (top, left) {
      const largestHeight = window.innerHeight - this.$refs.rightMenu.offsetHeight - 25
      const largestWidth = window.innerWidth - this.$refs.rightMenu.offsetWidth - 25

      if (top > largestHeight) top = largestHeight

      if (left > largestWidth) left = largestWidth

      this.top = top + 'px'
      this.left = left + 'px'
    },
    closeRightClickMenu () {
      this.displaySection = undefined
      this.rightMenuVisible = false
      this.rightClickedItem = undefined
    },
    async openRightClickMenu (item, $event) {
      $event.preventDefault()
      if (!$event.ctrlKey && !$event.metaKey && !this.desktopGroupsSelected.find(ds => ds.id === item.id)) {
        this.$store.commit('Device/CLEAR_DESKTOPS_SELECTED_RIGHT')
        this.$store.commit('Device/CLEAR_DESKTOP_GROUPS_SELECTED_RIGHT')
      }
      if (this.desktopGroupsSelected.findIndex(dktp => dktp.id === item.id) === -1) {
        this.$store.commit('Device/ADD_DESKTOP_GROUPS_SELECTED_RIGHT', [...this.desktopGroupsSelected, item])
      }
      this.rightClickedItem = item
      this.rightMenuVisible = true
      Vue.nextTick(() => {
        this.setRightClickMenuPosition($event.y, $event.x)
      })
    }
  },
  computed: {
    desktopGroupsSelected () {
      return this.$store.state.Device.desktop_groups_selected_right
    },
    modificationsInSelected () {
      const affectedIds = this.$store.state.Device.desktops_affected.map(da => da.Medium.id)
      const selectedIds = this.$store.state.Device.desktops_selected_right.map(dsr => dsr.LocalPlayList)
      const intersection = affectedIds.filter(id => selectedIds.includes(id))
      return intersection.length
    },
    userRoleNames () {
      return this.$store.state.User.user.Roles.map(role => role.name)
    },
    userHasCoreOSPrivilege () {
      return this.userRoleNames.includes('admin') || this.userRoleNames.includes('manager')
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
@import "../Common/rightClick.scss";
</style>



// WEBPACK FOOTER //
// src/components/Device/RightClickDesktopGroupsMenu.vue